/* eslint-disable no-nested-ternary */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Alert, Drawer, Popconfirm } from 'antd';
import { INFINITE_EXPIRY_DATE, QUANTITY } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import dayjs from 'dayjs';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import BatchForm from '@Components/Common/Form/BatchForm';
import './style.scss';
import ViewBatchCustomFields from '../ViewBatchCustomFields';

/**
 * OfferForm component
 *
 * @param file
 */
class BatchesList extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  /**
   *
   */
  componentDidMount() {
    const { expiryDays } = this.props;
    this.setState({
      expiryDate: expiryDays > 0 ? (dayjs().add(expiryDays || 0, 'day')) : dayjs(INFINITE_EXPIRY_DATE),
    });
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      batches, expiryDays, expiryDate, batchUom, selectedBatch, tenantProductId, uomList, setSelectedBatch, onAddNewBatch, prefillCostPrice, prefillMrp,
      prefillLot, locationId, locationPath, destDepartmentId, nextBatchCode, MONEY, hideRemoveOption,
    } = this.props;
    const { newBatchModal } = this.state;
    return (
      <div>
        {
          batches?.map((item) => {
            const expiryMoment = dayjs(dayjs(item?.expiry_date).format('YYYY-MM-DD'));
            let shelfLife = 0;
            if (dayjs().isSameOrBefore(expiryMoment)) {
              shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
            }
            let shelfLifePct = Math.round(((shelfLife / expiryDays) * 100));
            if (expiryDate === INFINITE_EXPIRY_DATE) shelfLifePct = 100;
            return (
              <Fragment key={item?.batch_id}>
                <div
                  className={`batch-list__item ${selectedBatch?.batch_id === item?.batch_id ? 'batch-list__item-selected' : ''}`}
                  onClick={() => setSelectedBatch(item)}
                >
                  <H3Text text={`Batch# ${item?.custom_batch_number || item?.batch_number}`} className="batch-list__item-title" />
                  {selectedBatch?.batch_id === item?.batch_id ? <H3Text text="SELECTED" className="batch-list__item-selected-tag" /> : ''}
                  {expiryDays > 0 && (
                    <div className="batch-shelf-life">
                      <div
                        className="progress-line__wrapper"
                        style={{
                          width: '120px',
                          backgroundColor: expiryDays > 0 ? `${shelfLifePct < 25 && shelfLifePct >= 0 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)'}` : 'rgba(216,51,15,0.2)',
                        }}
                      >
                        <div
                          className="progress-line"
                          style={{
                            width: expiryDays > 0 ? `${shelfLifePct > 100 ? 100 : shelfLifePct}%` : '100%',
                            backgroundColor: expiryDays > 0 ? `${shelfLifePct < 25 && shelfLifePct >= 0 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A'}` : '#17B54D',
                          }}
                        />
                      </div>
                      <span>
                        {expiryDays < 0 ? 'No Expiry' : `${shelfLife} Days (${shelfLifePct}%)`}
                      </span>
                    </div>
                  )}
                  {!item?.batch_id ? (
                    <Fragment>
                      <Alert
                        message="New batch will be created if GRN is done in this batch."
                        type="info"
                        showIcon
                        className="new-batch__tag-warning"
                      />
                    </Fragment>
                  ) : ''}
                  <div className="batch-list__item-info">
                    <div className="ant-row">
                      {item?.batch_id && (
                        <Fragment>
                          <div className="ant-col-md-12">
                            Available Quantity
                          </div>

                          <div className="ant-col-md-12">
                            {`${QUANTITY(item?.available_qty, batchUom?.precision)} ${(batchUom?.uqc?.toProperCase() || batchUom?.[0]?.uqc?.toProperCase())}`}
                          </div>
                        </Fragment>
                      )}
                      {item?.expiry_date !== INFINITE_EXPIRY_DATE && (
                        <Fragment>
                          <div className="ant-col-md-12">
                            Expiry Date
                          </div>
                          <div className="ant-col-md-12">
                            {item?.expiry_date === INFINITE_EXPIRY_DATE ? 'NA' : dayjs(item?.expiry_date).format('MMM DD, YYYY')}
                          </div>
                        </Fragment>
                      )}
                      {item?.lot_number ? (
                        <Fragment>
                          <div className="ant-col-md-12">
                            Lot Number
                          </div>
                          <div className="ant-col-md-12">
                            {item?.lot_number}
                          </div>
                        </Fragment>
                      ) : ''}
                      {item?.cost_price ? (
                        <Fragment>
                          <div className="ant-col-md-12">
                            Cost Price
                          </div>
                          <div className="ant-col-md-12">
                            {MONEY(item?.cost_price)}
                          </div>
                        </Fragment>
                      ) : ''}
                      {item?.mrp ? (
                        <Fragment>
                          <div className="ant-col-md-12">
                            MRP
                          </div>
                          <div className="ant-col-md-12">
                            {MONEY(item?.mrp)}
                          </div>
                        </Fragment>
                      ) : ''}
                      <Fragment>
                        <div className="ant-col-md-12">
                          Warehouse Section
                        </div>
                        <div className="ant-col-md-12">
                          {item?.inventory_location_path || '-'}
                        </div>
                        {
                          item?.is_rejected_batch && (
                            <div className="ia-type-tag" style={{ backgroundColor: '#f15353' }}>
                              <H3Text text="Rejected" className="" />
                            </div>
                          )
                        }
                        <div className="ant-col-md-16">
                          <ViewBatchCustomFields
                            source="BATCH_LIST"
                            customFields={item?.custom_fields}
                          />
                        </div>
                      </Fragment>

                    </div>
                  </div>
                </div>
                {!item?.batch_id && (
                  <Popconfirm
                    placement="topRight"
                    title="Are you sure you want remove the new batch?"
                    onConfirm={(event) => {
                      event.preventDefault();
                      const { removeNewBatch } = this.props;
                      removeNewBatch();
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    {!hideRemoveOption && (
                      <div className="batch-list__item-remove-wrapper">
                        <div className="batch-list__item-remove">
                          Remove New Batch
                        </div>
                      </div>
                    )}
                  </Popconfirm>
                )}
              </Fragment>
            );
          })
        }
        {!batches?.find((i) => !i.batch_id) ? (
          <div className="new-batch__button" onClick={() => this.setState({ newBatchModal: true })}>
            + New Batch
          </div>
        ) : ''}

        <Drawer
          open={newBatchModal}
          onClose={() => this.setState({ newBatchModal: false })}
          width="400px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '355px' }}>
              <H3Text text="Add New Batch" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ newBatchModal: false })} />
            </div>
          </div>
          <BatchForm
            callback={() => {
              this.setState({ newBatchModal: false });
            }}
            uomList={uomList}
            locationId={locationId}
            locationPath={locationPath}
            expiryDays={expiryDays}
            tenantProductId={tenantProductId}
            isTemporaryBatch
            batchUom={batchUom}
            onSubmit={(batch) => onAddNewBatch(batch, () => this.setState({ newBatchModal: false }))}
            prefillCostPrice={prefillCostPrice}
            prefillMrp={prefillMrp}
            prefillLotNumber={prefillLot}
            destDepartmentId={destDepartmentId}
            nextBatchCode={nextBatchCode}
          />
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = () => ({

});

BatchesList.propTypes = {
  expiryDays: PropTypes.any,
  tenantProductId: PropTypes.any,
  batches: PropTypes.any,
  expiryDate: PropTypes.any,
  batchUom: PropTypes.any,
  onAddNewBatch: PropTypes.func,
  prefillCostPrice: PropTypes.any,
  prefillMrp: PropTypes.any,
  selectedBatch: PropTypes.any,
  nextBatchCode: PropTypes.string,
  removeNewBatch: PropTypes.any,
  uomList: PropTypes.any,
  setSelectedBatch: PropTypes.any,
  destDepartmentId: PropTypes.any,
  hideRemoveOption: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchesList));
